export default {
  one_time_event: 'One time',
  persistent: 'Persistent',
};



// WEBPACK FOOTER //
// ./src/models/AlertsRepeats.js